export default "::ng-deep body {\n  min-width: 1200px;\n  padding-top: 120px !important;\n}"